
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M5.134 0a3.023 3.031 0 00-3.01 3.019v4.943a.821.824 0 00.821.822.821.824 0 00.821-.822V3.018c0-.768.602-1.373 1.368-1.373h9.854c.767 0 1.37.605 1.37 1.373V12.9c0 .768-.603 1.373-1.37 1.373h-4.925a.821.824 0 00-.821.823.821.824 0 00.821.824h4.927A3.023 3.031 0 0018 12.9V3.018a3.023 3.031 0 00-3.01-3.019z","overflow":"visible"}}),_c('path',{attrs:{"d":"M7.704 7.71a2.55 2.55 0 00-1.806.751L4.665 9.7a.81.812 0 000 1.149.81.812 0 001.144 0L7.044 9.61a.932.934 0 01.66-.275c.526 0 .937.41.937.939 0 .248-.1.485-.275.662l-1.234 1.237a.81.812 0 000 1.15.81.812 0 001.146 0l1.234-1.238a2.552 2.559 0 00.748-1.811A2.57 2.578 0 007.704 7.71zm-1.487 3.25a.81.812 0 00-.58.235l-2.16 2.167a.81.812 0 000 1.152.81.812 0 001.147 0l2.16-2.167a.81.812 0 000-1.15.81.812 0 00-.567-.238zm-3.24.773a.81.812 0 00-.58.236L.748 13.625c-.48.48-.748 1.13-.748 1.81A2.573 2.573 0 002.556 18c.678 0 1.327-.27 1.806-.75l1.65-1.652a.81.812 0 000-1.152.81.812 0 00-1.146 0L3.216 16.1a.932.934 0 01-.66.274.925.928 0 01-.936-.939c0-.248.099-.484.275-.662l1.648-1.653a.81.812 0 000-1.15.81.812 0 00-.567-.235z","overflow":"visible"}})])])
          )
        }
      }
    